<template>
	<MainLayout>
		<div class="container">
			<b-card>
				<b-button class="float-right" @click="() => newUser('admin')">{{ $t("users.newUser") }}</b-button>
				<h2>{{ $t("global.users") }}</h2>
				<hr/>
				<b-form @submit="evt => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'users-index-list' );}">
					<div class="row">
						<b-form-group class="col-md-2" :label="$t('global.search')">
							<b-form-input
								v-model="usersFilters.search"
								type="text"
							/>
						</b-form-group>
						<b-form-group class="col" label=".">
							<b-button type="submit" variant="primary">{{
									$t("global.search")
								}}
							</b-button>
						</b-form-group>
					</div>
				</b-form>
				<AjaxTable
					id="users-index-list"
					:filters="usersFilters"
					:columns="usersColumns"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					resource="users"
				>
					<template v-slot:cell(actions)="row">
						<div class="text-center">
							<b-button
								@click="
											event =>
												userView(
													row.item,
													row.index,
													event
												)
										"
								type="button"
								size="sm"
								class="mr-1"
								variant="info"
							>
								<md-icon icon="edit"/>
							</b-button>
							<b-button
								@click="
											event =>
												userDelete(
													row.item,
													row.index,
													event
												)
										"
								type="button"
								size="sm"
								class="mr-1"
								variant="danger"
							>
								<md-icon icon="delete"/>
							</b-button>
							<b-button
										@click="
											event =>
												userResetPassword(
													row.item,
													row.index,
													event
												)
										"
										type="button"
										size="sm"
										class="mr-1"
										variant="warning"
									>
										<md-icon icon="lock" />
							</b-button>
						</div>
					</template>
				</AjaxTable>
			</b-card>
		</div>
		<ResetPassword ref="resetPassword" />
		<Single ref="single" :success-callback="successCallback"/>
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout.vue";
import AjaxTable from "../../helpers/AjaxTable.vue";
import Single from "./Single.vue";
import Resize from "../../helpers/Resize.js";
import ResetPassword from "./ResetPassword.vue"

export default {
	components: {MainLayout, ResetPassword, Single, AjaxTable},
	mixins: [Resize],
	data() {
		return {
			modalInfo: {
				modelId: -1
			},
			usersFilters: {
				accessType: ["operation", "master", "admin"],
				search: ""
			},
			driversFilters: {
				accessType: ["driver"],
				search: ""
			},
			usersColumns: [
				{key: "id", label: "ID"},
				{key: "firstName", label: this.$t("users.name")},
				{key: "email", label: this.$t("users.email")},
				{key: "accessType", label: this.$t("users.access")},
				{key: "status", label: this.$t("users.status")},
				{key: "actions", label: this.$t("users.actions")}
			],
			driversColumns: [
				{key: "id", label: "ID"},
				{key: "firstName", label: this.$t("users.name")},
				{key: "email", label: this.$t("users.email")},
				{key: "status", label: this.$t("users.status")},
				{key: "actions", label: this.$t("users.actions")}
			],
			sortBy: 'id',
			sortDesc: true,
		};
	},
	methods: {
		successCallback() {
			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ["userDriverOpts"], forceRefresh: true});
			this.$root.$emit("bv::refresh::table", "users-index-list");
			this.$root.$emit("bv::refresh::table", "drivers-index-list");
		},
		userView(item) {
			this.$refs["single"].loadModel(item.id);
		},
		userResetPassword(item){
			this.$refs["resetPassword"].loadModel(item.id)
		},
		newUser(accessType) {
			this.$refs["single"].loadModel(-1);
			this.$refs["single"].setAccessType(accessType);
		},
		userDelete(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					this.$root.api
						.delete(`/users/${item.id}`)
						.then(() => {
							this.$root.showAlert(
								this.$t("users.msgRemoved"),
								{variant: "warning"}
							);
							this.successCallback();
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		}
	},
	mounted() {
	}
};
</script>

<style scoped>
.tabs-style {
	padding: 0.5rem;
}

.tabs-style-mobile {
	display: none;
}

@media (max-width: 1000px) {
	.tabs-style-mobile {
		display: flex;
		justify-content: space-between;
	}

	.tabs-style {
		display: none;
	}

	.tabs-body-style .tab-pane {
		padding: 0;
	}
}
</style>
